import { TextField, useTheme } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import React from "react";

interface IProps {
  options: string[];
  value: any;
  onChange: (value: any) => void;
  placeholder?: string;
}

const DropdownComponent: React.FC<IProps> = ({
  options,
  value,
  onChange,
  placeholder,
}) => {
  const theme = useTheme();
  return (
    <Autocomplete
      options={options}
      value={value}
      style={{
        marginRight: theme.spacing(2),
      }}
      fullWidth
      onChange={(_, value) => onChange(value)}
      renderInput={(params) => (
        <TextField
          {...params}
          color="primary"
          variant="outlined"
          margin="dense"
          placeholder={placeholder}
        />
      )}
    />
  );
};

export default DropdownComponent;
